import React from 'react';
import { useSelector } from 'react-redux';

function TimeDisplay() {
  const layersArr = useSelector(state => state.map.layersArr);
  const frame = useSelector(state => state.map.frame);
  return (
    <div>
      {layersArr[frame] ? layersArr[frame] : 'Trouble getting forecast time'}
    </div>
  )
}

export default TimeDisplay
